const answers = [
  'No breach by any Party of its material obligations hereunder will entitle the non-breaching' +
    ' Party/Parties to recover damages, or affect any of such non-breaching Party’s/Parties’' +
    ' obligations hereunder, unless the Party alleged to be in breach fails to remedy such breach' +
    ' within <DATE> days following receipt of notice thereof.',

  'Notwithstanding the foregoing or anything to the contrary contained in this Agreement, no' +
    ' breach by any Party of any provision hereof shall give another Party the right to injunctive or' +
    ' other equitable relief with respect to the production, distribution, sale, lease, license or other' +
    ' exploitation of the Work(s) hereunder; it being understood that the non-breaching' +
    ' Party’s/Parties’ sole remedy for any such breach shall be limited to damages, if any.',
];

export default (options, type) => {
  let content = '';
  let checked = true;

  if (options.field1 === 0) {
    if (options.field3) {
      content = answers[0].replace('<DATE>', options.field3) + '<SPACE>';
    } else {
      content =
        answers[0].replace(
          '<DATE>',
          `<i><u>&nbsp;&nbsp;select date&nbsp;&nbsp;</u></i>`
        ) + '<SPACE>';
      checked = false;
    }
    if (options.field2 === 0) {
      content += answers[1] + '<SPACE>';
    }
    if (type === 'premium' && options.field2 !== 0 && options.field2 !== 1) {
      checked = false;
    }
  } else if (options.field1 === 1) {
    if (type === 'premium') {
      if (options.field2 === 0) {
        content += answers[1] + '<SPACE>';
      } else if (options.field2 === 1) {
        content += 'Intentionally omitted.<SPACE>';
      } else {
        checked = false;
      }
    } else {
      content += 'Intentionally omitted.<SPACE>';
    }
  } else {
    checked = false;
  }

  if (content !== '') {
    content = content.substring(0, content.length - 7);
  }

  return {
    content: content.replace(new RegExp('<SPACE>', 'g'), ' '),
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/CureRemedies.js